// extracted by mini-css-extract-plugin
var _1 = "LabelSelectDropdownListItemContentInfoText-modulelabelListItemContentInfoText__qRgb_ SelectDropdownEntityListItemContentInfoText-moduleSelectDropdownEntityListItemContentInfoText__I9Xt8";
export { _1 as "labelListItemContentInfoText" }
